import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';
import { useFeatureServices } from 'src/feature-app/hooks';
import { CarlineWithOffers } from 'src/types';
 
const getLowestPriceOffer = (carline: CarlineWithOffers) => {
  let lowerPrice = Number(carline.ofertas[0].cuota);

  carline.ofertas.forEach((oferta) => {
    if (Number(oferta.cuota) < Number(lowerPrice && oferta.cuotaText !=='Ocasión')) { 
      lowerPrice = oferta.cuota;
    }
  });

  return carline.ofertas.find((oferta) => Number(oferta.cuota) === Number(lowerPrice));
};

export const useInfoPageService = (selectedCarline?: any, newCanonicalUrl?: string): any => {
  const pageInfoService = useFeatureServices()['page-info-service'] as PageInfoServiceV1;
  const cuota = selectedCarline ? getLowestPriceOffer(selectedCarline) : null;

  if(selectedCarline) {
    const pageTitleString = `Ofertas y stock: tu ${selectedCarline.title} desde ${cuota.cuotaText} con MyRenting | Volkswagen España`; 
    const canonicalUrlString = newCanonicalUrl; 
    const keywordsString = `oferta, ${selectedCarline.name}`;
    const descriptionString = `Encuentra el ${selectedCarline.title} que estás buscando por menos de lo que imaginas. Busca tu oferta y conduce muy pronto ese ${selectedCarline.title} que tienes en la cabeza.`;
    const image = `${selectedCarline.mediaAssets?.D6MOFASideview}`;

    pageInfoService.setPageInfo({
      seo: { 
        pageTitle: pageTitleString,
        canonicalUrl: canonicalUrlString,
        keywords: keywordsString,
        description: descriptionString,
        twitter: {
          twitterTitle: pageTitleString,
          twitterDescription: descriptionString,
          twitterImage: image,
          twitterCard: 'summary'
        },
        og: {
          ogTitle: pageTitleString,
          ogDescription: descriptionString,
          ogImage: image,
          ogUrl: canonicalUrlString
        }
      }
    });
  } else {
    
    pageInfoService.setPageInfo();
    
  }

  return null;
};
